import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EXAMS, DEFAULT_TITLE} from './college-predictor.constant';
import { Subscription } from 'rxjs';
import { CollegePredictorService } from './college-predictor.service';
import { AlertService } from '../shared/services/alert.service';
import { UtilityService } from '../shared/services/utility.service';
import { FORM_TYPE } from '../shared/components/form/free-trial-form/form.constant';
import { BRANCH_ICON } from "./college-predictor.constant";
declare var $: any;
@Component({
  selector: 'app-college-predictor',
  templateUrl: './college-predictor.component.html',
  styleUrls: ['./college-predictor.component.scss']
})
export class CollegePredictorComponent implements OnInit {
  public activeSubscription = new Subscription();
  public selectedExam: string = DEFAULT_TITLE.EXAM;
  public userRank: string = '';
  public branchesList = [];
  public categoryList = [];
  public quotaList =[];
  public selectedCategory:string;
  public selectedBranchList =[];
  public enableVerifyOTPPopup: boolean = false;
  public mobileInfo: any = {};
  public showCollege = false;
  public predColleges;
  public selectedQuota;
  public collegesData;
  public get EXAMS(){
    return EXAMS;
  }
  public get checkForm(){
    return this.selectedCategory &&  this.selectedBranchList && this.userRank && (this.selectedQuota || this.selectedExam !== 'jee-main');
  }
  public get FORM_TYPE(){
    return FORM_TYPE.COLLEGE_PRED;
  }
  public get DEFAULT_EXAM_MAIN(){
    return DEFAULT_TITLE.EXAM;
  }
  constructor(private route: ActivatedRoute,
    private collegePredictorService:CollegePredictorService,
    private alertService:AlertService,
    private _utility:UtilityService) { }

  ngOnInit(): void {
    
    this.activeSubscription.add(this.route.params.subscribe(param => {
      this.selectedExam = param.exam || this.selectedExam;
      const collegePredData = this._utility.getCollegePred;
      this._utility.userIdFetch.next('');
      this.showCollege = false;
      const owl = $('.college-predictor').owlCarousel({
        loop: true,
        responsiveClass: true,
        nav: true,
        margin: 0,
        autoplay: true,
        smartSpeed: 400,
        center: true,
        stagePadding: 60,
        responsive: {
          0: {
            items: 2,
          },
          600: {
            items: 3
          },
          1200: {
            items: 5
          }
        }
      });
      const exam = EXAMS[this.selectedExam].TYPE;
      this.getBranches(exam);
    if (!!collegePredData['rank'] && !!collegePredData['branch']?.length) {
      this._utility.setCollegePred({});
      this.getCollegeResult(collegePredData);
    } else {
      this.getCategory(exam);
      this.getQuota(exam);
    }
    }));
}

  getBranches(exam){
    this.activeSubscription.add(
      this.collegePredictorService.getBranches(exam).subscribe(res=>{
        if(res && res.code ===200){
          this.branchesList = res.data;
          this.addBranchesImages();
        }else{
          this.alertService.showErrorMessage(res.message);
        }
      },error=>{
         this.alertService.showErrorMessage(error.message);
      })
    );
  }

  addBranchesImages(): void {
    this.branchesList.forEach((branch: any) => {
      branch.image = '/assets/img/s3-images/picasso/branch-icon/' + BRANCH_ICON[branch.name];
    });
  }

  getCategory(exam){
    this.activeSubscription.add(
      this.collegePredictorService.getExamCategory(exam).subscribe(res=>{
        if(res && res.code ===200){
          this.categoryList = res.data;
        }else{
          this.alertService.showErrorMessage(res.message);
        }
      },error=>{
         this.alertService.showErrorMessage(error.message);
      })
    );
  }

  getQuota(exam){
    this.activeSubscription.add(
      this.collegePredictorService.getQuotaCategory(exam).subscribe(res=>{
        if(res && res.code ===200){
          this.quotaList = res.data;
        }else{
          this.alertService.showErrorMessage(res.message);
        }
      },error=>{
         this.alertService.showErrorMessage(error.message);
      })
    );
  }

  getUserRank(event){
    this.userRank=event.target.value;
  }

  selectBranch(branchId){
    const elementIndex= this.selectedBranchList.indexOf(branchId);
    if(elementIndex !== -1){
      this.selectedBranchList.splice(elementIndex,1);
      return;
    }
    if(this.selectedBranchList.length >=3 ){
      this.alertService.showErrorMessage('Already 3 branches selected!');
      return;
    }
    this.selectedBranchList.push(branchId);
  }

  selectCategory(categoryId){
    this.selectedCategory = categoryId;
  }

  selectQuota(quotaId){
    this.selectedQuota = quotaId;
  }

  onSubmit(){
    if(!this.checkForm){
      return;
    }
    const payload = {
      branch :  this.selectedBranchList,
      category : this.selectedCategory,
      rank :this.userRank
    };
    if(this.selectedExam === DEFAULT_TITLE.EXAM){
      payload['quota'] =this.selectedQuota;
    }
    this.selectedBranchList=[];
    this.selectedCategory = undefined;
    this.selectedQuota =undefined;
    this.getCollegeResult(payload);
  }

  getCollegeResult(payload){
    if(!payload.branch.length){
      return;
    }
    this.activeSubscription.add(
      this.collegePredictorService.getColleges(payload,EXAMS[this.selectedExam].TYPE).subscribe(res=>{
        if(res && res.code ===200){
          this.predColleges=res.data;
          this.showCollege=true;
        }else{
          this.alertService.showErrorMessage(res.message);
        }
      },error=>{
         this.alertService.showErrorMessage(error.message);
      })
    );
  }

}
